var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.247,
    height: 28.241,
    viewBox: "0 0 22.247 28.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gender",
    transform: "translate(-4.866 -1.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79507",
    "data-name": "Path 79507",
    d: "M8.86,17.17a5.877,5.877,0,0,1,3.16-9.96c6.75-1.08,9.49,8.14,3.59,11.06a1.121,1.121,0,0,0,.99,2.01A8.125,8.125,0,0,0,19.48,8.11l2.39-2.39V8a1.125,1.125,0,0,0,2.25,0V2.96A1.14,1.14,0,0,0,23,1.88H18a1.125,1.125,0,0,0,0,2.25h2.28L17.87,6.54A8.107,8.107,0,0,0,7.34,18.83c1.06,1.03,2.58-.61,1.52-1.66Z",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79508",
    "data-name": "Path 79508",
    d: "M24.66,13.17c-1.02-1-2.6.59-1.52,1.66a5.877,5.877,0,0,1-3.16,9.96c-6.74,1.08-9.49-8.14-3.59-11.06a1.121,1.121,0,0,0-.99-2.01,8.123,8.123,0,0,0-2.88,12.17L11.5,24.91,9.8,23.2a1.124,1.124,0,0,0-1.59,1.59l1.71,1.7-1.71,1.7A1.124,1.124,0,0,0,9.8,29.78l1.7-1.71,1.7,1.71a1.124,1.124,0,0,0,1.59-1.59l-1.71-1.7,1.03-1.03A8.107,8.107,0,0,0,24.64,13.17Z",
    fill: "#5b5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/genderIcon.2386a1fbcd9d32867b2141e624e36480.svg";
export { ForwardRef as ReactComponent };